import { Button } from "@chakra-ui/button";
import { Box, HStack, Stack, Text } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import { Table, Tbody, Td, Tfoot, Th, Thead, Tr } from "@chakra-ui/table";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function ComparePriceTable({ services }) {
  const checkColors = ["#000000", "#00A2E8", "#FFB200", "#8562EA"];
  return (
    <>
      {Object.keys(services).length > 0 ? (
        <Table variant="striped">
          <Thead>
            <Tr
              sx={{
                "th:nth-of-type(2)": { bg: checkColors[0] },
                "th:nth-of-type(3)": { bg: checkColors[1] },
                "th:nth-of-type(4)": { bg: checkColors[2] },
                "th:nth-of-type(5)": { bg: checkColors[3] },
                th: {
                  color: "#FFFFFF",
                  py: 6,
                  fontWeight: "700",
                  fontSize: "17px",
                  lineHeight: "22px",
                  textAlign: "center",
                },
              }}
            >
              <Th></Th>
              {services.map((service) => (
                <Th key={service.name}>{service.name}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody
            sx={{
              "td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5)": {
                textAlign: "center",
              },
            }}
          >
            <Tr>
              <Td>Max Number Of Users</Td>
              {services.map((service, i) => (
                <Td key={`numberOfUsers${i}`}>{service.numberOfUsers}</Td>
              ))}
            </Tr>
            <Tr>
              <Td>Max Storage Capacity</Td>
              {services.map((service, i) => (
                <Td key={`storage${i}`}>{service.storage}</Td>
              ))}
            </Tr>
            <Tr>
              <Td>Price (NGN)</Td>
              {services.map((service, i) => (
                <Td key={`duration${i}`}>{service.duration[0].price}</Td>
              ))}
            </Tr>

            {/* core */}
            <Tr>
              <Td
                sx={{
                  background: "none !important",
                  border: "none !important",
                }}
              >
                <Text my="10" sx={{ color: "#00A2E8", fontWeight: "700" }}>
                  CORE
                </Text>
              </Td>
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Basic Setting</Td>
              {services.map((service, i) => {
                return service.basicSetting ? (
                  <Td key={`basicSetting${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`basicSetting${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Advanced Setting</Td>
              {services.map((service, i) => {
                return service.advancedSetting ? (
                  <Td key={`advancedSetting${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`advancedSetting${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Analytics</Td>
              {services.map((service, i) => {
                return service.analytics ? (
                  <Td key={`analytics${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`analytics${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Automatic Onboarding</Td>
              {services.map((service, i) => {
                return service.automaticOnboarding ? (
                  <Td key={`automaticOnboarding${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`automaticOnboarding${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Entrance Exam</Td>
              {services.map((service, i) => {
                return service.entranceExam ? (
                  <Td key={`entranceExam${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`entranceExam${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Learners Certification</Td>
              {services.map((service, i) => {
                return service.learnersCertification ? (
                  <Td key={`learnersCertification${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`learnersCertification${i}`}></Td>
                );
              })}
            </Tr>

            {/* modules */}
            <Tr>
              <Td
                sx={{
                  background: "none !important",
                  border: "none !important",
                }}
              >
                <Text my="10" sx={{ color: "#00A2E8", fontWeight: "700" }}>
                  MODULES
                </Text>
              </Td>
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Course Management</Td>
              {services.map((service, i) => {
                return service.courseMgt ? (
                  <Td key={`courseMgt${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`courseMgt${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>User Management</Td>
              {services.map((service, i) => {
                return service.userMgt ? (
                  <Td key={`userMgt${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`userMgt${i}`}></Td>
                );
              })}
            </Tr>
            <Tr
              sx={{
                "td:nth-of-type(2)": { color: checkColors[0] },
                "td:nth-of-type(3)": { color: checkColors[1] },
                "td:nth-of-type(4)": { color: checkColors[2] },
                "td:nth-of-type(5)": { color: checkColors[3] },
              }}
            >
              <Td>Learners Survey</Td>
              {services.map((service, i) => {
                return service.learnersSurvey ? (
                  <Td key={`learnersSurvey${i}`}>
                    <Box>
                      <FontAwesomeIcon icon={faCheck} />
                    </Box>
                  </Td>
                ) : (
                  <Td key={`learnersSurvey${i}`}></Td>
                );
              })}
            </Tr>
          </Tbody>

          <Tfoot>
            <Tr>
              <Th></Th>
              {services.map((service, i) => (
                <Th key={`subscribeBtn${i}`}>
                  <Button
                    isFullWidth
                    sx={{
                      textDecoration: "none",
                      ":hover, :focus": { textDecoration: "none" },
                      py: "6",
                      mt: "5",
                      border: `2px solid ${checkColors[i]}`,
                      borderRadius: "100px",
                      color: checkColors[i],
                    }}
                    as="a"
                    href={`/services/${service.name}`}
                  >
                    Subscribe
                  </Button>
                </Th>
              ))}
            </Tr>
          </Tfoot>
        </Table>
      ) : (
        <Stack spacing="6">
          <HStack justify="flex-end">
            <Skeleton width="20%" height="20"></Skeleton>
            <Skeleton width="20%" height="20"></Skeleton>
            <Skeleton width="20%" height="20"></Skeleton>
          </HStack>
          <Skeleton width="100%" height="12"></Skeleton>
          <Skeleton width="100%" height="12"></Skeleton>
          <Skeleton width="100%" height="12"></Skeleton>
          <Skeleton width="100%" height="12"></Skeleton>
          <Skeleton width="100%" height="12"></Skeleton>
          <Skeleton width="100%" height="12"></Skeleton>
          <Skeleton width="100%" height="12"></Skeleton>
        </Stack>
      )}
    </>
  );
}
